import API from "./axios";

/**
 * Phase 36da.99.bp — Vendor Payment API client.
 *
 * Wraps:
 *   GET   /api/vendor-payments/paged
 *   GET   /api/vendor-payments/{id}
 *   GET   /api/vendor-payments/vendor-balance?vendorId=X
 *   GET   /api/vendor-payments/outstanding-bills?vendorId=X
 *   GET   /api/vendor-payments/total
 *   POST  /api/vendor-payments
 *   PATCH /api/vendor-payments/{id}/cancel
 */
const vendorPaymentApi = {
  paged:         (params)  => API.get("/vendor-payments/paged", { params }),
  getById:       (id)      => API.get(`/vendor-payments/${id}`),
  vendorBalance: (vendorId) => API.get("/vendor-payments/vendor-balance", { params: { vendorId } }),
  outstandingBills: (vendorId) => API.get("/vendor-payments/outstanding-bills", { params: { vendorId } }),
  total:         (params)  => API.get("/vendor-payments/total", { params }),
  create:        (data)    => API.post("/vendor-payments", data),
  cancel:        (id)      => API.patch(`/vendor-payments/${id}/cancel`),
  delete:        (id)      => API.delete(`/vendor-payments/${id}`),
};

export default vendorPaymentApi;